<template>
  <div class="cont-log">
    <header  class="hed-log"></header>
    <form class="login" @submit.prevent="login">

        <div class="logo"></div>
      <div class="logo-text">
        <h1>Персональний кабінет</h1>
      </div>

      <input class="" required v-model="username" type="text" placeholder="логін"/>
      <input class="" required v-model="password" type="password" placeholder="Пароль"/>

      <button class="btn-login" type="submit">Вхід</button>
<!--      <a href="" class="res_pass">ЗАБУЛИ ЛОГІН АБО ПАРОЛЬ?</a>-->
    </form>
    <footer>
      <div class="entrance">

      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data(){
    return {
      username : "",
      password : ""
    }
  },
  created() {
    if (this.$store.getters.isLoggedIn)
    {
      this.$router.push('/')
    }
  },
  methods: {
    login: function () {
      let username = this.username
      let password = this.password
      this.$store.dispatch('login', { username, password })
          .then(() => this.$router.push('/'))
          .catch(
              err => {
                if (err.response.data.errorCode === 103) {
                  this.$swal.fire(
                      {
                        title: 'Помилка авторизації',
                        text: 'Невірний логін або пароль',
                        confirmButtonText: "ЗРОЗУМІЛО",
                        showCloseButton: true,
                        buttonsStyling: false,
                        width: '390px',
                        height: '191px'
                      });
                }
              }
          )
    }
  }
}
</script>
<style>
.hed-log {
  display: none;
}
.cont-log {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  align-items: stretch;
  text-align: center;
}
.entrance {
  background: url(../assets/Entrance2-2.png);
  background-size: contain;
  height: 165px;
  width: 1031px;
  margin: 15px auto 124px auto;
}
footer {
  background:  var(--general-green);
  height: 304px;
  margin-top: 40px;
  width: 100%;
}
.btn-login {
  margin-top: 40px;
  //margin-bottom: 16px;
  background:  var(--main-blue);
  border: none;
  border-radius: 20px;
  color:  var(--middel-grey);
  width: 165px;
  height: 40px;
}
.btn-login:focus,
.btn-login:hover{
  background:  var(--soft-purple);
}
.cont-log input:focus{
  outline: none;
  //box-shadow: 0px 0px 4px #4E4CC7;
  border: 1px solid  var(--soft-purple);
}
.cont-log input {
  width: 360px;
  height: 40px;
  display: block;
  margin: 0 auto 17px;
  background:  var(--usual-white);
  border: 1px solid  var(--strong-grey);
  box-sizing: border-box;
  border-radius: 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  text-align: center;
  text-transform: capitalize;
  font-feature-settings: 'cpsp' on;;
}

.logo {
  /*position: relative;*/
  margin-top: 129px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 22px;
  height: 75px;
  width: 276px;
  /*left: 37.5%;*/
  /*right: 37.5%;*/
  /*top: 15.62%;*/
  /*bottom: 74.84%;*/
  background: url(../assets/SVITPRO-logo.png);
  background-size: contain;
  background-repeat: no-repeat;
}
.logo-text {
  margin: 0 auto 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-text  h1{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 1;
  /* or 38% */
  text-align: center;
  color:  var(--main-blue);
}
@media  (max-width: 1024px)  and (orientation: portrait) {
  .logo {
    margin-top: 224px;
    margin-bottom: 27px;
    width: 311px;
  }
  .logo-text{
    margin-bottom: 49px;
  }
  .logo-text h1{
    font-size: 46px;
    line-height: 50px;
    width: 400px;
  }
  .cont-log input {
    width: 374px;
    height: 58px;
    margin: 0 auto 27px;
    font-size: 18px;
    line-height: 19px;
  }
  .btn-login {
    margin-top: 17px;
    height: 58px;
    font-size: 18px;
    line-height: 19px;
  }
  footer{
    height: 234px;
  }
  .entrance {
    width: 637px;
    height: 102px;
    margin: 24px auto 108px auto;
  }
}
@media  (max-width: 768px)  and (orientation: portrait) {
  .hed-log {
    display: block;
    height: 43px;
    background-color:  var(--general-green);
  }
  .entrance {
    display: none;
  }
  .logo {
    margin-top: 98px;
    margin-bottom: 26px;
    width: 212px;
  }
  .logo-text {
    margin-bottom: 41px;
  }
  .logo-text  h1{
    font-size: 38px;
    line-height: 1;
  }
  .cont-log input {
    width: 292px;
    height: 45px;
    margin: 0 auto 21px;
  }
  .btn-login {
    margin-top: 13px;
    height: 45px;
  }
  footer{
    height: 85px;
  }
}
@media  (max-height: 667px)  and (orientation: portrait) {
  .hed-log{
    display: none;
   }
}
@media  (max-width: 360px)  and (orientation: portrait) {
  .hed-log{
    display: none;
  }
  .entrance {
    display: none;
  }
  .logo {
    margin-top: 77px;
    margin-bottom: 21px;
    width: 194px;
  }
  .logo-text h1{
    font-size: 38px;
    line-height: 38px;
  }
  .cont-log input {
    width: 292px;
    height: 45px;
    margin: 0 auto 21px;
  }
  .btn-login {
    margin-top: 13px;
    height: 45px;
  }
}
@media ( max-width: 640px)  and (orientation: landscape) {
  .entrance {
    display: none;
  }
  .logo {
    margin-top: 2px;
  }
}

@media  (max-width: 280px)  and (orientation: portrait) {
  .cont-log input {
    width: 220px;
  }
}


</style>

